export default __webpack_public_path__ + "static/media/cn_bass_amp_bg.a3c36361.webp";